import {QuizAnswerImageModel} from "@/models/quiz.model";

export interface BlanksData {
  text: string;
  blanks: Blank[];
}

export interface Blank {
  id?: number;
  htmlId?: string;
  position: number;
  type: BlankType;
  responses: BlankResponse[];
}

export interface BlankResponse {
  label?: string;
  type: BlankResponseType;
  correctAnswer: boolean;
  caseSensitive: boolean;
  image?: QuizAnswerImageModel;
}


export enum BlankType {
  TEXT= 'TEXT',
  MULTI_SELECT = 'MULTI_SELECT',
}

export enum BlankResponseType {
  RGX_PATTERN= 'RGX_PATTERN',
  EXACT_MATCH= 'EXACT_MATCH',
  CONTAIN_MATCH = 'CONTAIN_MATCH',
  MULTI_SELECT_OPTION = 'MULTI_SELECT_OPTION',
}
